module.exports = __webpack_public_path__ + "media/metronic/_theme/media/project-logos/6-64315cbc20949939a65eabfc628c40cf.png";